import criptoJS from "crypto-js";
import { setAuthorization } from "services/axios/api";
import { getErrorsByApi } from "shared/helpers/getErrorsByApi";
import { ApiResponse } from "shared/interfaces/api";
import { api } from "services/axios/api";
import configs from "Config";

export async function getTokenFromUrl() {
    const queryParams = new URLSearchParams(window.location.search);
    const hashId = queryParams.get("hashId");

    if (hashId == null) {
        return;
    }

    const tokenEnv = configs.REACT_APP_API_KEY || "";

    const decodedCriptoValue = atob(hashId);
    const decryptedBytes = criptoJS.AES.decrypt(decodedCriptoValue, tokenEnv);
    const decriptoHashId = decryptedBytes.toString(criptoJS.enc.Utf8);

    if (decriptoHashId == null) {
        return;
    }

    const jwtToken = await getTokenViaHashId(decriptoHashId) ?? "";

    sessionStorage.setItem("@MOF:token", jwtToken);
    setAuthorization(jwtToken);
};

async function getTokenViaHashId(hashId: string) {
    try {
        const response: ApiResponse<string> = await api.get(
            `/Autenticacao/ObterTokenViaHashId?hashId=${hashId}`
        );
        
        // ✅ Validar response antes de acessar .data
        if (!response || !response.data) {
            console.error("❌ Resposta inválida da API ao obter token via hashId");
            return null;
        }
        
        return response.data;
    } catch (error: any) {
        // ✅ Tratamento de erro mais robusto
        let errorMessage = "Tivemos problemas internos ao obter JwtToken via hashId";
        
        // Validar estrutura do erro antes de acessar propriedades
        if (error?.data?.errors?.Mensagens && error.data.errors.Mensagens.length > 0) {
            errorMessage = error.data.errors.Mensagens[0];
        } else if (error?.response?.data?.messages && error.response.data.messages.length > 0) {
            errorMessage = error.response.data.messages[0];
        } else if (error?.message) {
            errorMessage = error.message;
        }

        console.error("❌ Erro ao obter token via hashId:", errorMessage);
        getErrorsByApi(error, errorMessage);
        
        // ✅ Retorno explícito de null em caso de erro
        return null;
    }
}